import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box,
  Link,
} from '@mui/material';

const ApplicationTable = ({ data, loading, type }) => {
  // Format date to dd-mm-yyyy hh:mm:ss
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data || data.length === 0) {
    return (
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell align="center">
                <Typography variant="h6">No Application Found</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  // Render different table types
  if (type === 'complaint') {
    return (
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>Sr. No.</strong></TableCell>
              <TableCell><strong>Lab Id.</strong></TableCell>
              <TableCell><strong>Laboratory Name</strong></TableCell>
              <TableCell><strong>Complaint Against</strong></TableCell>
              <TableCell><strong>Complaint for</strong></TableCell>
              <TableCell><strong>Complaint Number</strong></TableCell>
              <TableCell><strong>Complaint File</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.ApplicationNo}</TableCell>
                <TableCell>{item.LaboratoryName}</TableCell>
                <TableCell>{item.Complaint_Against}</TableCell>
                <TableCell>{item.complaintType}</TableCell>
                <TableCell>{item.ComplaintNumber}</TableCell>
                <TableCell>
                  {item.url && (
                    <Link href={item.url} target="_blank" rel="noopener noreferrer">
                      View
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  // Default table for FA, RA, and Verification
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
            <TableCell><strong>Sr. No.</strong></TableCell>
            <TableCell><strong>Lab Id.</strong></TableCell>
            <TableCell><strong>Laboratory Name</strong></TableCell>
            <TableCell><strong>Standard</strong></TableCell>
            <TableCell><strong>Discipline</strong></TableCell>
            {/* <TableCell><strong>Scope</strong></TableCell> */}
            <TableCell><strong>Dealing Officer</strong></TableCell>
            <TableCell><strong>FA Dates (Appln. Date, Ass. Date)</strong></TableCell>
            <TableCell><strong>Assessment team details</strong></TableCell>
            <TableCell><strong>Status</strong></TableCell>
            <TableCell><strong>Punched Date</strong></TableCell>
            <TableCell><strong>Remarks</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index} hover>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{item.ApplicationNo}</TableCell>
              <TableCell>{item.LaboratoryName}</TableCell>
              <TableCell>{item.standard}</TableCell>
              <TableCell>{item.Disciplines}</TableCell>
              {/* <TableCell>{item.Groups}</TableCell> */}
              <TableCell>{item.DOName}</TableCell>
              <TableCell>{item.Dates}</TableCell>
              <TableCell>{item.FAteam}</TableCell>
              <TableCell>{item.Description}</TableCell>
              <TableCell>{formatDate(item.Inserted_Date)}</TableCell>
              <TableCell>{item.Do_Remarks}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ApplicationTable;
